module.exports = __webpack_public_path__ + "static/media/about-us.02abd108.svg";